module.exports = __webpack_public_path__ + "static/media/Ilustrasi-Stop-Bulying.699add42.jpg";